/**
 * The Change Password rules (US-117548 §D) — labels and order from the AC, tests from the BE DTO.
 * Deliberately not auth's `PASSWORD_RULES`: forgot-password has six rules in another order, and
 * its special-character test counts a space (grilling Q18).
 */
/** The longest password the BE accepts; also the New Password field's `maxLength`. */
export const CHANGE_PASSWORD_MAX_LENGTH = 64;

export const CHANGE_PASSWORD_RULES = [
  { id: 'lower', label: 'At least one lowercase letter', test: (v: string) => /[a-z]/.test(v) },
  { id: 'upper', label: 'At least one uppercase letter', test: (v: string) => /[A-Z]/.test(v) },
  {
    id: 'special',
    label: 'At least one special character',
    // Printable ASCII punctuation only — a space is not special.
    test: (v: string) => /[!-/:-@[-`{-~]/.test(v),
  },
  { id: 'number', label: 'At least one number', test: (v: string) => /\d/.test(v) },
  {
    id: 'length',
    label: 'Min 8 characters and Max 64 characters',
    test: (v: string) => v.length >= 8 && v.length <= CHANGE_PASSWORD_MAX_LENGTH,
  },
] as const;

export function isChangePasswordValid(value: string): boolean {
  return CHANGE_PASSWORD_RULES.every((rule) => rule.test(value));
}
